export class Spool {


  public spoolId: string;
  public name: string;

  /**
   * Default constructor, doing nothing
   */
  constructor() {
  }

}
